/**
 * V5 报告页展示词表 —— 把后端 code（ability / L 级）映射到中文显示标签和前端图标。
 *
 * ⚠️ 这不是 schema 真源。Schema 真源是后端：
 *    - backend/apps/reports/schemas/v5_report_schema.py
 *    - backend/apps/dimensions/defaults.py (5 力 canonical)
 *
 * 本文件只用于把后端 code 渲染成 UI 上的中文名/图标，避免在 React 组件里散落硬编码。
 *
 * 长期方案见 docs/archive/v5/AI-HANDOFF.md：
 *  - ability 中文名最好由后端在 report payload 里带出来（或单独 labels API），
 *    避免后台改名要发版（V5-升级规划 §7.5）。在那之前这里保持与 defaults.py 对齐。
 *  - 素质（traits）已从报告链永久移除，前端不再引用。
 */

// ---------------------------------------------------------------------------
// 5 力（与 backend/apps/dimensions/defaults.py CANONICAL_DIMENSIONS 对齐）
// 顺序 = canonical sort_order（雷达图 / 进度条按此顺序绘制）
// ---------------------------------------------------------------------------
export const ABILITY_LABELS = {
  ai_leverage:           { name: 'AI借力',   sort: 1 },
  ai_symbiosis:          { name: 'AI共生',   sort: 2 },
  ai_team_leadership:    { name: 'AI带队',   sort: 3 },
  ai_governance:         { name: 'AI治理',   sort: 4 },
  ai_strategic_foresight:{ name: 'AI谋势',   sort: 5 },
};

export const ABILITY_ORDER = Object.keys(ABILITY_LABELS).sort(
  (a, b) => ABILITY_LABELS[a].sort - ABILITY_LABELS[b].sort,
);

// ---------------------------------------------------------------------------
// L 级中文名 → 4 时期（来自 V5-升级规划领导力模型，已冻结）
// ---------------------------------------------------------------------------
export const L_GRADE_LABELS = {
  L1: '初用期',
  L2: '惯用期',
  L3: '扩散期',
  L4: '重构期',
};

// ---------------------------------------------------------------------------
// Assessment depth → 报告版本中文名
// (V5-升级规划 §7.3.1：基础版 / 标准版 / 专业版；设计稿"快速版"已弃)
// ---------------------------------------------------------------------------
export const DEPTH_VERSION_LABELS = {
  quick:    '基础版',
  standard: '标准版',
  deep:     '专业版',
};

